export default __webpack_public_path__ + "static/media/metamask.a64f7505.svg";